export const currentPositions = [
  'business',
  'engineering',
  'marketing',
  'operations',
  'people',
  'finance',
  'product',
  'sales',
  'legal_compliance',
  'marketing',
  'design',
  'security',
  'federal',
  'it',
  'gtm'
];
